import React, { useState } from 'react';
import { 
  ShieldCheckIcon,
  KeyIcon,
  CogIcon,
  DocumentTextIcon
} from '@heroicons/react/24/outline';

const Security: React.FC = () => {
  const [securityEvents] = useState([
    {
      id: 1,
      type: 'success',
      description: '정상 로그인',
      details: 'Chrome 브라우저에서 성공적으로 로그인했습니다.',
      timestamp: '2024-01-02 14:30:25',
      ip: '192.168.1.100',
      message: '성공적인 로그인',
      time: '5분 전'
    },
    {
      id: 2,
      type: 'warning',
      description: 'API 키 갱신 필요',
      details: 'News API 키가 만료 예정입니다.',
      timestamp: '2024-01-02 13:15:10',
      ip: '-',
      message: 'API 키 만료 경고',
      time: '1시간 전'
    },
    {
      id: 3,
      type: 'success',
      description: '2FA 인증 성공',
      details: 'Google Authenticator로 인증이 완료되었습니다.',
      timestamp: '2024-01-02 14:25:45',
      ip: '192.168.1.100',
      message: '2단계 인증 완료',
      time: '10분 전'
    }
  ]);

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center mb-6">
        <ShieldCheckIcon className="h-6 w-6 mr-2 text-blue-500" />
        <h2 className="text-2xl font-bold text-white">보안 설정</h2>
      </div>

      <div className="space-y-6">
        {/* 보안 개요 */}
        <div className="bg-white dark:bg-dark-800 rounded-lg p-6 border border-light-300 dark:border-dark-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
            <ShieldCheckIcon className="h-5 w-5 mr-2 text-green-600 dark:text-green-500" />
            보안 상태
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="text-center">
              <div className="text-3xl font-bold text-green-600 dark:text-green-400">98%</div>
              <div className="text-sm text-gray-600 dark:text-gray-400">보안 점수</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-600 dark:text-blue-400">2FA</div>
              <div className="text-sm text-gray-600 dark:text-gray-400">인증 활성화</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-yellow-600 dark:text-yellow-400">7일</div>
              <div className="text-sm text-gray-600 dark:text-gray-400">마지막 감사</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-purple-600 dark:text-purple-400">AES-256</div>
              <div className="text-sm text-gray-600 dark:text-gray-400">암호화</div>
            </div>
          </div>
        </div>

        {/* API 키 관리 */}
        <div className="bg-white dark:bg-dark-800 rounded-lg p-6 border border-light-300 dark:border-dark-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
            <KeyIcon className="h-5 w-5 mr-2 text-blue-600 dark:text-blue-400" />
            API 키 관리
          </h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-light-100 dark:bg-dark-700 rounded-lg border border-light-300 dark:border-dark-600">
              <div>
                <div className="font-medium text-gray-900 dark:text-white">Binance API Key</div>
                <div className="text-sm text-gray-600 dark:text-gray-400">••••••••••••••••abcd1234</div>
                <div className="text-xs text-gray-500 dark:text-gray-500">마지막 사용: 2분 전</div>
              </div>
              <div className="flex space-x-2">
                <span className="px-2 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 text-xs rounded">활성</span>
                <button className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded transition-colors">
                  편집
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* 보안 설정 */}
        <div className="bg-white dark:bg-dark-800 rounded-lg p-6 border border-light-300 dark:border-dark-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
            <CogIcon className="h-5 w-5 mr-2 text-gray-600 dark:text-gray-400" />
            보안 설정
          </h3>
          <div className="space-y-4">
            <button className="w-full bg-white dark:bg-dark-700 hover:bg-light-100 dark:hover:bg-dark-600 text-gray-900 dark:text-white py-3 px-4 rounded-lg text-left flex items-center justify-between border border-light-300 dark:border-dark-600 transition-colors">
              <span>이중 인증 (2FA) 설정</span>
              <span className="text-green-600 dark:text-green-400">✓ 활성화됨</span>
            </button>
          </div>
        </div>

        {/* 보안 로그 */}
        <div className="bg-white dark:bg-dark-800 rounded-lg p-6 border border-light-300 dark:border-dark-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
            <DocumentTextIcon className="h-5 w-5 mr-2 text-gray-600 dark:text-gray-400" />
            최근 보안 이벤트
          </h3>
          <div className="space-y-3">
            {securityEvents.map((event) => (
              <div key={event.id} className="bg-light-100 dark:bg-dark-700 rounded-lg p-4 border border-light-300 dark:border-dark-600">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <span className="text-2xl">
                      {event.type === 'success' ? '✅' :
                       event.type === 'warning' ? '⚠️' :
                       event.type === 'error' ? '❌' : 'ℹ️'}
                    </span>
                    <div>
                      <div className="font-medium text-gray-900 dark:text-white">{event.description}</div>
                      <div className="text-sm text-gray-600 dark:text-gray-400">{event.time}</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-600 dark:text-gray-400">{event.ip}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security; 